import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  protected allowEmptyUserPermission = true;

  public userPermissions$ = new BehaviorSubject<string[]>([]);

  getPermissionsList(): Observable<string[]> {
    return this.userPermissions$.asObservable();
  }

  hasNoPermissions(): boolean {
    const permissions = this.userPermissions$.value;
    return permissions.length < 1 || permissions.includes('no_permission');
  }

  decodePermissionsList(permissions: string[]): boolean {
    this.userPermissions$.next(permissions);
    return true;
  }

  hasAccess(permissions: string[]): boolean {
    return permissions?.some((permission) => this.userPermissions$.value?.includes(permission));
  }

  hasPermission(permissionName: string): boolean {
    return this.hasAccess([permissionName]);
  }

  hasAccessAsync(permissions: string[]): Observable<boolean> {
    return this.userPermissions$.pipe(
      map((userPermissions) => {
        return permissions?.some((permission) => userPermissions.includes(permission));
      }),
    );
  }

  hasAccessOnlyTo(permissions: string[]): boolean {
    return !this.userPermissions$.value?.length
      ? false
      : this.userPermissions$.value?.every((permission) => permissions?.includes(permission));
  }

  hasAccessOnlyToAsync(permissions: string[]): Observable<boolean> {
    return this.userPermissions$.pipe(
      map((userPermissions) => {
        return !userPermissions?.length
          ? false
          : userPermissions?.every((permission) => permissions.includes(permission));
      }),
    );
  }
}
